import * as Yup from 'yup';

const sportsTypeSchema = Yup.object({
    code: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Code is required'),
    display_name: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Display name is required')
});

export default sportsTypeSchema;